export default {
  gba_expert_back_list: '返回列表',
  gba_expert_detail_title: '卫经专家详情',
  gba_expert_panel_ai_summary_desc: '从专家定位、准入影响和沟通方向快速查看关键判断。',
  gba_expert_ai_analyze: '让AI分析',
  gba_expert_analysis_dimensions: '分析维度',
  gba_expert_specialty: '擅长领域',
  gba_expert_research_areas: '研究方向',
  gba_expert_intro: '个人简介',
  gba_expert_access_impact_overview: '准入影响概览',
  gba_expert_key_roles: '关键角色',
  gba_expert_impact_pathway_analysis: '影响路径分析',
  gba_expert_institution_policy_relation: '机构与政策关系',
  gba_expert_academic_network: '学术网络',
  gba_expert_empty_tab: '当前 tab 暂无可展示内容。',
  gba_expert_tab_ai_summary: 'AI摘要',
  gba_expert_tab_core_profile: '核心档案',
  gba_expert_tab_access_impact: '准入影响',
  gba_expert_tab_academic_activity: '学术与动态',
  gba_expert_default_name: '卫经专家',
  gba_expert_metric_evidence_score: '证据分',
  gba_expert_metric_last_verified: '最近核验',
  gba_expert_blueprint_position_title: '专家定位',
  gba_expert_blueprint_position_desc: '总结其属于高校/政策/医保支付/HTA 哪一类关键影响者，以及在准入链路中的位置。',
  gba_expert_blueprint_risk_title: '准入风险与机会',
  gba_expert_blueprint_risk_desc: '指出其对 NRDL、药经评估、医保支付方式或政策传播最可能产生影响的环节。',
  gba_expert_blueprint_opening_title: '沟通切入点',
  gba_expert_blueprint_opening_desc: '结合研究方向、近期公开发言和学协会角色，给出更合适的对话主题。',
  gba_expert_blueprint_next_actions_title: '后续动作建议',
  gba_expert_blueprint_next_actions_desc: '提示应继续补证的资料、建议关注的会议与媒体窗口，以及可能需要联动的团队。',
  gba_expert_fact_current_org: '当前单位',
  gba_expert_fact_org_type: '单位类型',
  gba_expert_fact_department: '所属部门',
  gba_expert_fact_current_titles: '当前职务',
  gba_expert_fact_academic_titles: '学术头衔',
  gba_expert_timeline_education: '学业经历',
  gba_expert_timeline_work: '工作经历',
  gba_expert_timeline_titles: '当前职务与历任职务',
  gba_expert_impact_nrdl_relevance: 'NRDL相关性',
  gba_expert_impact_scope: '影响层级',
  gba_expert_impact_strength: '影响强度',
  gba_expert_impact_pathway: '影响路径',
  gba_expert_role_nrdl: '目录准入角色',
  gba_expert_role_hta: 'HTA角色',
  gba_expert_role_pharmacoeconomics: '药经角色',
  gba_expert_role_payer: '医保支付角色',
  gba_expert_role_policy: '政策研究角色',
  gba_expert_academic_role_association: '学协会任职',
  gba_expert_academic_role_journal: '期刊任职',
  gba_expert_academic_content_articles: '学术文章与研究文章',
  gba_expert_academic_content_research: '科研项目 / 基金 / 专利',
  gba_expert_academic_content_meetings: '会议动态 / 论坛 / 演讲',
  gba_expert_academic_content_media: '直播 / 访谈 / 新闻',
  gba_expert_ai_prompt_intro: '请基于以下卫经专家档案生成摘要：{name}',
  gba_expert_ai_prompt_customer_id: '客户ID：{id}',
  gba_expert_ai_prompt_nrdl: 'NRDL相关性：{value}',
  gba_expert_ai_prompt_portrait: '当前画像：{value}',
  gba_expert_ai_prompt_pathways: '影响路径：{value}',
  gba_expert_ai_prompt_instruction: '请输出专家定位、准入影响、建议沟通切入点和待补充证据。',
  ga_admin_overview_title: 'GBA Pilot & GA NRDL',
  ga_admin_overview_subtitle: '查看 GA 与 GBA 团队在客户覆盖、拜访执行和反馈认同度上的整体进展。',
  ga_admin_section_overall: '整体概览',
  ga_admin_section_overall_desc: '通过量化指标汇总团队执行、客户反馈和当前重点推进状态。',
  ga_admin_section_ai_daily: 'AI近期摘要',
  ga_admin_section_ai_daily_desc: '基于近期拜访反馈和任务进展生成的管理摘要。',
  ga_admin_further_analysis: '进一步分析',
  ga_admin_ai_prompt_daily: '请基于当前 GA管理员驾驶舱数据，总结近期或本周最重要的管理洞察。',
  ga_admin_section_feedback_overview: '客户反馈概览',
  ga_admin_section_feedback_overview_desc: '分别查看临床医生和卫经专家的最新反馈变化。',
  ga_admin_section_sync_focus: '重点跟进事项',
  ga_admin_section_sync_focus_desc: '当前建议优先补齐的客户覆盖与反馈问题。',
  ga_admin_sync_priority: '协同优先',
  ga_admin_owner_team: '责任团队',
  ga_admin_next_step: '下一步',
  ga_admin_execution_title: 'GBA Pilot & GA NRDL',
  ga_admin_execution_subtitle: '查看团队推进进度、客户覆盖状态和当前需要跟进的执行问题。',
  ga_admin_execution_section_overview: '执行总览',
  ga_admin_execution_section_overview_desc: '快速了解团队覆盖、拜访执行和反馈填写情况。',
  ga_admin_execution_section_pipeline: '团队推进漏斗',
  ga_admin_execution_section_pipeline_desc: '查看各阶段推进情况，识别需要重点补强的环节。',
  ga_admin_team_gba: 'GBA团队',
  ga_admin_team_ga: 'GA团队',
  ga_admin_execution_section_queue: '重点跟进队列',
  ga_admin_execution_section_queue_desc: '跟踪客户覆盖缺口、反馈填写缺口和下一步动作。',
  ga_admin_ai_prompt_queue: '请根据当前重点跟进队列，生成一版本周客户覆盖与反馈补齐建议。',
  ga_admin_generate_priority: '生成优先级',
  ga_admin_execution_section_quality_alert: '执行质量预警',
  ga_admin_execution_section_quality_alert_desc: '这些问题会影响后续判断与管理建议，建议优先补齐。',
  ga_admin_strategy_title: 'GBA Pilot & GA NRDL',
  ga_admin_strategy_subtitle: '按临床医生与卫经专家拆分全部反馈，总结关键洞察并生成可执行建议。',
  ga_admin_analysis_section_feedback: '反馈总结分析',
  ga_admin_analysis_section_feedback_desc: '分别汇总临床医生与卫经专家的所有关键反馈，查看共识、分歧和高频问题。',
  ga_admin_analysis_deep_dive: 'AI深度分析',
  ga_admin_strategy_section_ai: 'AI策略建议',
  ga_admin_strategy_section_ai_desc: '围绕当前重点问题，提供可直接推进的策略建议。',
  ga_admin_strategy_view_details: '查看建议详情',
  ga_admin_strategy_section_risk: '风险预警',
  ga_admin_strategy_section_risk_desc: '提示当前需要重点关注的策略风险与推进障碍。',
  ga_admin_strategy_section_report_templates: '常用分析提示',
  ga_admin_strategy_section_report_templates_desc: '沉淀可复用的管理分析问题，快速展开反馈、客户和执行质量复盘。',
  ga_admin_prompt_send_to_ai: '前往AI助手提问',
  ga_admin_customers_title: 'GBA Pilot & GA NRDL',
  ga_admin_customers_subtitle: '查看临床医生与卫经专家的覆盖情况，识别重点客户与后续跟进机会。',
  ga_admin_ai_interpret: 'AI解读',
  ga_admin_sync_label: '{level}协同',
  ga_admin_institution_meta: '{region} · 临床 {clinicalCount} · 专家 {expertCount}',
  ga_admin_relation_view_title: '客户关系视图',
  ga_admin_relation_view_desc: '查看专家与临床客户的联动情况。',
  ga_admin_ai_prompt_relation_view: '请基于客户关系视图，识别最值得优先跟进的客户。',
  ga_admin_identify_covisit: '识别协访机会',
  ga_admin_suggested_action: '建议动作',
  ga_admin_relation_list_title: '关系列表',
  ga_admin_relation_list_desc: '以列表方式查看重点关系、连接强度和后续建议。',
  ga_admin_suggestion: '建议',
  ga_admin_entity_institution: '机构',
  ga_admin_view_list: '列表视图',
  ga_admin_view_network: '关系视图',
  ga_admin_customers_clinical_title: '临床客户全景',
  ga_admin_customers_clinical_desc: '聚焦临床反馈、重点议题和后续推进建议。',
  ga_admin_customers_ai_summary_label: 'AI总结',
  ga_admin_customers_clinical_summary: '当前临床客户池整体呈现“认知持续升温、证据诉求前置”的特征；头部客户已开始从单点疗效关注转向长期管理与院内落地，适合联合 GA 做分层推进。',
  ga_admin_customers_clinical_list_title: '临床客户列表',
  ga_admin_customers_clinical_list_desc: '查看具体客户、标签和后续跟进入口。',
  ga_admin_customers_clinical_prompt: '请解读当前临床医生客户池，指出最值得优先联动 GA 的客户。',
  ga_admin_customers_expert_title: '卫经专家全景',
  ga_admin_customers_expert_desc: '聚焦专家熟悉度、沟通反馈和准入推进状态。',
  ga_admin_customers_expert_summary: '卫经专家池整体进入“熟悉度提升、准入讨论更具体”的阶段；优先跟进熟悉度高且沟通认同度较好的专家，能更快沉淀有效反馈。',
  ga_admin_customers_expert_list_title: '卫经专家列表',
  ga_admin_customers_expert_list_desc: '查看重点专家、沟通状态和后续推进对象。',
  ga_admin_customers_expert_prompt: '请解读当前卫经专家客户池，指出最值得和 GBA 联动推进的对象。',
  ga_admin_customers_institution_title: '客户分组全景',
  ga_admin_customers_institution_desc: '从客户分组查看临床与专家覆盖情况及当前进展。',
  ga_admin_customers_institution_summary: '当前客户覆盖已具备基础盘面，后续应优先补齐高潜客户的拜访与反馈。',
  ga_admin_customers_institution_list_title: '客户分组列表',
  ga_admin_customers_institution_list_desc: '查看具体客户分组覆盖情况、当前状态和跟进潜力。',
  ga_admin_customers_institution_prompt: '请基于当前客户名单，判断哪些客户最适合优先跟进。',
  ga_admin_choose_view: '选择视图',
  ga_admin_tab_overview: '总览',
  ga_admin_tab_customers: '客户',
  ga_admin_tab_ai: 'AI助手',
  ga_admin_tab_execution: '执行',
  ga_admin_tab_strategy: '分析',
  ga_admin_header_switch_role_desc: '切换当前身份',
  ga_admin_header_user_info_title: '当前用户信息',
  ga_admin_header_user_name: '用户名称',
  ga_admin_header_user_id: '用户ID',
  ga_admin_header_current_role: '当前角色',
  ga_admin_header_language: '语言/Language',
  ga_admin_header_lang_zh: '中文',
  ga_admin_header_lang_en: 'English',
  ga_admin_header_date: '日期',
  ga_admin_header_close: '关闭',
  ga_admin_role_admin: 'GA管理员',
  ga_admin_role_sales: '销售',
  ga_admin_role_medical_manager: '医学经理',
  ga_admin_role_medical_admin: '医学部管理员',
  ga_admin_switched_to_chinese: '已切换至中文',
  ga_admin_switched_to_english: 'Switched to English',
  ga_admin_switch_role_failed: '切换角色失败',
  ga_admin_role_info_missing: '未获取到角色信息',
  ga_admin_loading_overview: '正在加载GA/GBA数据...',
  ga_admin_loading_customers: '正在加载GA/GBA客户数据...',
  ga_admin_loading_execution: '正在加载GA/GBA执行数据...',
  ga_admin_loading_strategy: '正在加载GA/GBA分析数据...',
  ga_admin_error_overview: 'GA/GBA数据加载失败，请稍后重试或检查OData权限。',
  ga_admin_error_customers: 'GA/GBA客户数据加载失败，请稍后重试或检查接口权限。',
  ga_admin_error_execution: 'GA/GBA执行数据加载失败，请稍后重试或检查OData权限。',
  ga_admin_error_strategy: 'GA/GBA分析数据加载失败，请稍后重试或检查OData权限。',
  ga_admin_empty_feedback_tags: '暂无反馈标签',
  ga_admin_execution_section_monthly_visits: '月度拜访数量',
  ga_admin_execution_section_monthly_visits_desc: '按拜访时间统计2026年1月以来的已执行拜访数量。',
  ga_admin_execution_section_monthly_feedback: '月度反馈收集',
  ga_admin_execution_section_monthly_feedback_desc: '按反馈时间统计2026年1月以来已收集的关键反馈数量。',
  ga_admin_alert_collapse: '收起',
  ga_admin_alert_view_detail: '查看{type}',
  ga_admin_alert_hidden_count: '还有{count}条明细未展示',
  ga_admin_alert_detail: '明细',
  ga_admin_alert_customer: '客户',
  ga_admin_alert_expert: '专家',
  ga_admin_alert_visit: '拜访',
  ga_admin_alert_feedback: '反馈',
  ga_admin_main_answers: '主要回答：',
  ga_admin_count_feedback: '{count}条',
  ga_admin_count_customer: '{count}位',
  ga_admin_count_expert: '{count}位',
  ga_admin_month_label: '{month}月',
  ga_admin_unknown: '未知',
  ga_admin_unknown_customer: '未知客户',
  ga_admin_unknown_date: '未知日期',
  ga_admin_unnamed_key_question: '未命名关键问题',
  ga_admin_call_date_meta: '拜访日期：{date}',
  ga_admin_call_owner_meta: '拜访员工：{owner}',
  ga_admin_priority_high: '高优先',
  ga_admin_priority_medium: '中优先',
  ga_admin_analytics_type_clinical: '临床医生',
  ga_admin_analytics_stat_clinical_alignment_title: '临床医生认同度',
  ga_admin_analytics_stat_choice_feedback_change: '{count}条选择反馈',
  ga_admin_analytics_stat_clinical_alignment_desc: '基于GBA拜访反馈中“疾病认知”和“慢性偏头痛疾病负担”的选择结果。',
  ga_admin_analytics_stat_expert_alignment_title: '卫经专家沟通认同度',
  ga_admin_analytics_stat_expert_feedback_change: '{count}条专家反馈',
  ga_admin_analytics_stat_expert_alignment_desc: '基于GA拜访反馈中“沟通信息认同程度”的0-3分结果，2分及以上计为认同。',
  ga_admin_analytics_stat_gba_coverage_title: 'GBA客户覆盖',
  ga_admin_analytics_stat_ga_coverage_title: 'GA客户覆盖',
  ga_admin_analytics_stat_coverage_change: '{covered}/{total}客户已覆盖',
  ga_admin_analytics_stat_gba_coverage_desc: 'GBA团队共{count}次已执行拜访，覆盖临床医生目标客户。',
  ga_admin_analytics_stat_ga_coverage_desc: 'GA团队共{count}次已执行拜访，覆盖卫经专家目标客户。',
  ga_admin_analytics_highlight_coverage: 'GBA临床客户覆盖率{gbaRate}，GA卫经专家覆盖率{gaRate}。',
  ga_admin_analytics_highlight_alignment: '医生认同度{clinicalRate}，专家沟通认同度{expertRate}，均来自已填写的关键反馈。',
  ga_admin_analytics_highlight_feedback_rate: '当前反馈填写率：GBA {gbaRate}，GA {gaRate}。',
  ga_admin_analytics_highlight_gap: '仍有{count}位目标客户暂无已执行拜访记录，建议优先补齐客户覆盖。',
  ga_admin_analytics_highlight_no_gap: '目标客户已形成基础覆盖，下一步可聚焦反馈质量和认同度变化。',
  ga_admin_analytics_board_clinical_summary: '已识别{recognizedCount}条GBA关键反馈，其中开放文本{openTextCount}条。',
  ga_admin_analytics_board_expert_summary: '已识别{recognizedCount}条GA关键反馈，沟通认同按0-3分口径统计。',
  ga_admin_analytics_metric_disease_alignment: '疾病认知认同',
  ga_admin_analytics_metric_burden_alignment: '疾病负担认同',
  ga_admin_analytics_metric_text_feedback: '文本反馈数',
  ga_admin_analytics_metric_customer_familiarity: '客户熟悉度',
  ga_admin_analytics_metric_communication_alignment: '沟通认同度',
  ga_admin_analytics_metric_total_customers: '总客户数',
  ga_admin_analytics_metric_coverage_rate: '覆盖率',
  ga_admin_analytics_metric_feedback_customers: '有反馈客户',
  ga_admin_analytics_metric_feedback_experts: '有反馈专家',
  ga_admin_analytics_metric_positive_feedback_customers: '正向反馈客户',
  ga_admin_analytics_metric_clinical_alignment: '医生认同度',
  ga_admin_analytics_metric_total_feedback: '反馈总数',
  ga_admin_analytics_metric_expert_familiarity: '专家熟悉度',
  ga_admin_analytics_customer_clinical_summary: '当前临床目标客户{targetCount}位，已覆盖{coveredCount}位，覆盖率{coverageRate}；有{feedbackCustomerCount}位客户已形成关键反馈，正向反馈客户{positiveFeedbackCustomerCount}位。医生认同度{clinicalAlignment}，其中疾病认知认同{clinicalDisease}，疾病负担认同{clinicalBurden}。{gapText}',
  ga_admin_analytics_customer_clinical_gap: '仍有{count}位临床客户暂无已执行拜访记录。',
  ga_admin_analytics_customer_clinical_no_gap: '临床目标客户已形成基础覆盖。',
  ga_admin_analytics_customer_clinical_prompt: '请基于当前临床客户数据生成管理解读：目标客户{targetCount}位，已覆盖{coveredCount}位，覆盖率{coverageRate}，有反馈客户{feedbackCustomerCount}位，正向反馈客户{positiveFeedbackCustomerCount}位，医生认同度{clinicalAlignment}。请识别覆盖缺口、反馈质量和下一步客户跟进重点。',
  ga_admin_analytics_customer_expert_summary: '当前卫经专家目标客户{targetCount}位，已覆盖{coveredCount}位，覆盖率{coverageRate}；有{feedbackCustomerCount}位专家已形成关键反馈，正向反馈客户{positiveFeedbackCustomerCount}位。专家熟悉度{expertFamiliarity}，沟通认同度{expertAlignment}。{gapText}',
  ga_admin_analytics_customer_expert_gap: '仍有{count}位卫经专家暂无已执行拜访记录。',
  ga_admin_analytics_customer_expert_no_gap: '卫经专家目标客户已形成基础覆盖。',
  ga_admin_analytics_customer_expert_prompt: '请基于当前卫经专家客户数据生成管理解读：目标专家{targetCount}位，已覆盖{coveredCount}位，覆盖率{coverageRate}，有反馈客户{feedbackCustomerCount}位，正向反馈客户{positiveFeedbackCustomerCount}位，专家熟悉度{expertFamiliarity}，沟通认同度{expertAlignment}。请识别覆盖缺口、沟通认同情况和下一步专家跟进重点。',
  ga_admin_analytics_execution_gba_coverage_subvalue: '{covered}/{total}临床客户已覆盖',
  ga_admin_analytics_execution_ga_coverage_subvalue: '{covered}/{total}专家客户已覆盖',
  ga_admin_analytics_execution_visits_title: '已执行拜访数',
  ga_admin_analytics_execution_visits_subvalue: 'GA/GBA团队已执行拜访合计',
  ga_admin_analytics_execution_feedback_rate_title: '反馈填写率',
  ga_admin_analytics_execution_feedback_rate_subvalue: '{completed}/{total}次拜访已填写反馈',
  ga_admin_analytics_pipeline_total_customers: '总客户数',
  ga_admin_analytics_pipeline_covered_customers: '覆盖客户数',
  ga_admin_analytics_pipeline_feedback_customers: '有反馈客户数',
  ga_admin_analytics_pipeline_positive_feedback_customers: '正向反馈客户数',
  ga_admin_analytics_positive_rule_gba: 'GBA正向反馈口径：医生在偏头痛疾病认知上选择完全认同/基本认同，或在慢性偏头痛疾病负担上选择非常必要/必要，即视为正向反馈。',
  ga_admin_analytics_positive_rule_ga: 'GA正向反馈口径：卫经专家在沟通信息认同程度上给出2分及以上，即视为正向反馈。',
  ga_admin_analytics_status_pending_follow_up: '待跟进',
  ga_admin_analytics_status_in_progress: '进行中',
  ga_admin_analytics_status_normal: '正常',
  ga_admin_analytics_owner_ga_gba: 'GA团队 / GBA团队',
  ga_admin_analytics_queue_clinical_title: '临床客户覆盖补齐',
  ga_admin_analytics_queue_clinical_desc: '仍有{count}位临床目标客户暂无已执行拜访记录，建议优先安排客户触达。',
  ga_admin_analytics_queue_expert_title: '卫经专家覆盖补齐',
  ga_admin_analytics_queue_expert_desc: '仍有{count}位卫经专家暂无已执行拜访记录，建议优先安排专家沟通。',
  ga_admin_analytics_queue_feedback_title: '关键反馈质量补齐',
  ga_admin_analytics_queue_feedback_desc: '{missingFeedback}次拜访尚未填写关键反馈，{unrecognizedCount}条反馈未匹配到当前关键问题口径。',
  ga_admin_analytics_queue_monitor_title: '执行数据持续观察',
  ga_admin_analytics_queue_monitor_desc: '当前客户覆盖和反馈填写未发现明显缺口，可持续观察认同度变化。',
  ga_admin_analytics_alert_uncovered_clinical_title: '未覆盖临床客户',
  ga_admin_analytics_alert_uncovered_clinical_message: '仍有{count}位临床目标客户暂无GBA已执行拜访记录。',
  ga_admin_analytics_alert_uncovered_expert_title: '未覆盖卫经专家',
  ga_admin_analytics_alert_uncovered_expert_message: '仍有{count}位卫经专家暂无GA已执行拜访记录。',
  ga_admin_analytics_alert_missing_feedback_title: '未填写关键反馈的拜访',
  ga_admin_analytics_alert_missing_feedback_message: '{count}次拜访尚未填写关键反馈，认同度判断可能偏低。',
  ga_admin_analytics_alert_unrecognized_title: '未匹配关键问题口径的反馈',
  ga_admin_analytics_alert_unrecognized_message: '{count}条反馈未匹配到当前GA/GBA关键问题口径。',
  ga_admin_analytics_alert_healthy: '当前未发现明显数据质量预警。',
  ga_admin_analytics_strategy_coverage_title: '优先补齐目标客户覆盖',
  ga_admin_analytics_strategy_coverage_desc: '当前临床未覆盖{clinicalGap}位，专家未覆盖{expertGap}位。建议先按客户类型分别推进覆盖补齐。',
  ga_admin_analytics_strategy_coverage_action_clinical_gap: '优先补齐{count}位临床未覆盖客户',
  ga_admin_analytics_strategy_coverage_action_clinical_keep: '维持临床客户覆盖节奏',
  ga_admin_analytics_strategy_coverage_action_expert_gap: '优先补齐{count}位专家未覆盖客户',
  ga_admin_analytics_strategy_coverage_action_expert_keep: '维持专家客户覆盖节奏',
  ga_admin_analytics_strategy_coverage_action_sequence: '按最近拜访与反馈情况安排跟进顺序',
  ga_admin_analytics_strategy_coverage_prompt: '请基于当前GA/GBA客户覆盖与反馈数据生成下一步客户跟进建议：临床未覆盖{clinicalGap}位，专家未覆盖{expertGap}位，GBA反馈填写率{gbaRate}，GA反馈填写率{gaRate}。',
  ga_admin_analytics_strategy_feedback_title: '强化关键反馈填写质量',
  ga_admin_analytics_strategy_feedback_desc: '当前反馈填写率：GBA {gbaRate}，GA {gaRate}；仍有{missingFeedback}次拜访暂无关键反馈。',
  ga_admin_analytics_strategy_feedback_action_missing: '补齐{count}次未填写反馈',
  ga_admin_analytics_strategy_feedback_action_keep: '保持反馈填写闭环',
  ga_admin_analytics_strategy_feedback_action_unrecognized: '核对{count}条未匹配反馈',
  ga_admin_analytics_strategy_feedback_action_match_keep: '保持关键问题匹配口径',
  ga_admin_analytics_strategy_feedback_action_labels: '沉淀已填写文本反馈标签',
  ga_admin_analytics_strategy_feedback_prompt: '请根据当前未填写反馈和已填写关键问题生成执行质量提升计划：未填写反馈{missingFeedback}次，未匹配关键问题反馈{unrecognizedCount}条，GBA反馈填写率{gbaRate}，GA反馈填写率{gaRate}。',
  ga_admin_analytics_strategy_alignment_title: '围绕认同度差异调整沟通材料',
  ga_admin_analytics_strategy_alignment_desc: '医生认同度{clinicalAlignment}，专家沟通认同度{expertAlignment}。',
  ga_admin_analytics_strategy_alignment_action_gba_review: '复盘GBA负向选择反馈',
  ga_admin_analytics_strategy_alignment_action_gba_keep: '延续GBA正向沟通主题',
  ga_admin_analytics_strategy_alignment_action_ga_review: '复盘GA沟通认同低分反馈',
  ga_admin_analytics_strategy_alignment_action_ga_extract: '提炼GA高认同沟通素材',
  ga_admin_analytics_strategy_alignment_action_split: '按客户类型拆分下一轮沟通重点',
  ga_admin_analytics_strategy_alignment_prompt: '请基于医生认同度和专家沟通认同度差异生成下一轮沟通材料建议：医生认同度{clinicalAlignment}，专家沟通认同度{expertAlignment}，GBA开放文本{gbaOpenTextCount}条，GA开放文本{gaOpenTextCount}条。',
  ga_admin_analytics_report_prompt_weekly: '请基于当前GA/GBA数据生成本周管理摘要：GBA覆盖{gbaCovered}/{gbaTotal}，GA覆盖{gaCovered}/{gaTotal}，医生认同度{clinicalAlignment}，专家沟通认同度{expertAlignment}。',
  ga_admin_analytics_report_prompt_customer_review: '请生成重点客户复盘模板：临床未覆盖{clinicalGap}位，专家未覆盖{expertGap}位，GBA有反馈客户{gbaFeedbackCustomerCount}位，GA有反馈客户{gaFeedbackCustomerCount}位。',
  ga_admin_analytics_report_prompt_tracking: '请根据{missingFeedback}次缺失反馈和{unrecognizedCount}条未匹配关键问题反馈，生成GA/GBA团队下周执行追踪清单。',
  ga_admin_analytics_insight_positive_alignment: '正向认同{rate}',
  ga_admin_analytics_insight_positive_communication: '正向沟通认同{rate}',
  ga_admin_analytics_insight_main_answers: '主要回答：{answers}',
  ga_admin_analytics_insight_open_text: '包含{count}条开放文本',
  ga_admin_analytics_insight_default_desc: '该问题已有反馈记录，可继续结合原始反馈做深度解读。',
  ga_admin_analytics_no_open_feedback: '暂无可用开放文本反馈。',
  ga_admin_analytics_feedback_prompt_intro: '请基于当前{typeName}的全部拜访反馈，生成一段管理层可读的总结性分析。',
  ga_admin_analytics_feedback_prompt_context: '对象：{typeName}；团队：{teamName}；反馈总量：{totalCount}条。',
  ga_admin_analytics_feedback_prompt_metrics: '核心指标：{metrics}。',
  ga_admin_analytics_feedback_prompt_insights: '高频问题：{insights}。',
  ga_admin_analytics_feedback_prompt_details: '以下为用于辅助判断的反馈明细摘录，请结合整体统计识别主要共识、分歧、风险信号和下一步行动建议：\n{feedbackLines}',
  ga_admin_analytics_feedback_prompt_output: '输出格式请包含：1）总体结论；2）主要洞察；3）风险/待验证假设；4）下一步行动。',
  ga_admin_analytics_feedback_clinical_title: '临床医生反馈总结',
  ga_admin_analytics_feedback_expert_title: '卫经专家反馈总结',
  ga_admin_analytics_feedback_clinical_summary: '临床医生侧共收集{feedbackCount}条反馈，覆盖{feedbackCustomerCount}位客户；医生整体认同度{clinicalAlignment}，其中疾病认知认同{clinicalDisease}、疾病负担认同{clinicalBurden}。开放文本{openTextCount}条，适合继续提炼治疗现状、创新需求和下一轮沟通重点。',
  ga_admin_analytics_feedback_expert_summary: '卫经专家侧共收集{feedbackCount}条反馈，覆盖{feedbackCustomerCount}位专家；专家熟悉度{expertFamiliarity}，沟通认同度{expertAlignment}。开放文本{openTextCount}条，建议重点观察价值信息理解、准入关注点和预算影响相关问题。',
  ga_admin_mock_overview_stat_clinical_title: '临床认同度',
  ga_admin_mock_overview_stat_clinical_desc: '疾病认知和慢病管理认同持续改善',
  ga_admin_mock_overview_stat_expert_title: '专家沟通认同度',
  ga_admin_mock_overview_stat_expert_desc: 'NRDL相关信息的接受度继续提升',
  ga_admin_mock_overview_stat_gba_title: 'GBA执行进度',
  ga_admin_mock_overview_stat_gba_change: '12位客户待覆盖',
  ga_admin_mock_overview_stat_gba_desc: '重点临床客户覆盖较完整，仍有少数客户待推进',
  ga_admin_mock_overview_stat_ga_title: 'GA执行进度',
  ga_admin_mock_overview_stat_ga_change: '5位关键专家待推进',
  ga_admin_mock_overview_stat_ga_desc: '关键专家已覆盖过半，沟通深度仍需加强',
  ga_admin_mock_ai_highlight_1: '临床医生对“慢性偏头痛长期管理”的认同提升最快，西南与华东区域更明显。',
  ga_admin_mock_ai_highlight_2: 'GA 团队对卫经专家的触达逐步成型，但对支付路径的解释仍偏保守。',
  ga_admin_mock_ai_highlight_3: '拜访反馈越完整，客户判断越稳定，建议优先补齐 Top 客户的反馈记录。',
  ga_admin_mock_ai_highlight_4: 'AI 判断当前最值得联合攻坚的主题是“院内准入叙事 + 患者长期获益证据”。',
  ga_admin_mock_board_clinical_title: '临床医生反馈概览',
  ga_admin_mock_board_clinical_summary: '临床端已从疾病识别逐步过渡到长期管理认同，但对患者筛选、流程衔接仍有较多开放问题。',
  ga_admin_mock_board_expert_title: '卫经专家反馈概览',
  ga_admin_mock_board_expert_summary: '专家端对客户熟悉程度整体较好，但 NRDL 关键信息的共识仍不均衡，需要继续沉淀反馈。',
  ga_admin_mock_board_metric_disease: '疾病认知认同',
  ga_admin_mock_board_metric_management: '慢病管理认同',
  ga_admin_mock_board_metric_questions: '开放问题活跃度',
  ga_admin_mock_board_metric_familiarity: '客户熟悉度',
  ga_admin_mock_board_metric_alignment: '沟通认同程度',
  ga_admin_mock_board_metric_follow_up: '开放反馈数',
  ga_admin_mock_board_metric_follow_up_value: '14条',
  ga_admin_mock_tag_long_term: '长期管理',
  ga_admin_mock_tag_standard_care: '规范诊疗',
  ga_admin_mock_tag_patient_selection: '患者筛选',
  ga_admin_mock_tag_adherence: '依从性',
  ga_admin_mock_tag_payment_pathway: '支付路径',
  ga_admin_mock_tag_hospital_access: '院内准入',
  ga_admin_mock_tag_stakeholders: '关键利益相关者',
  ga_admin_mock_tag_value_story: '价值叙事',
  ga_admin_mock_institution_west_china: '四川大学华西医院',
  ga_admin_mock_institution_first_affiliated_sun_yat_sen: '中山大学附属第一医院',
  ga_admin_mock_institution_ruijin: '上海瑞金医院',
  ga_admin_mock_sync_focus_1_reason: '临床管理认同较高，但 NRDL 叙事未形成统一口径。',
  ga_admin_mock_sync_focus_1_owner: 'GBA西南组 / GA西南组',
  ga_admin_mock_sync_focus_1_next_action: '安排联合协访，补齐支付与患者路径话术。',
  ga_admin_mock_sync_focus_2_reason: '临床反馈集中在患者筛选，卫经专家已开始关注成本效益。',
  ga_admin_mock_sync_focus_2_owner: 'GBA华南组 / GA华南组',
  ga_admin_mock_sync_focus_2_next_action: '输出客户试点建议，推动关键反馈闭环。',
  ga_admin_mock_sync_focus_3_reason: '政策端沟通认可度提升，但临床端仍缺少典型场景案例。',
  ga_admin_mock_sync_focus_3_owner: 'GBA华东组 / GA华东组',
  ga_admin_mock_sync_focus_3_next_action: '通过 AI 生成联合拜访提纲，强化上市场景落地。',
  ga_admin_mock_person_li_xiaolan: '李晓岚',
  ga_admin_mock_title_director_physician_neuro: '神经内科主任医师',
  ga_admin_mock_city_chengdu: '成都',
  ga_admin_mock_priority_high: '高优先',
  ga_admin_mock_tag_gba_focus: 'GBA重点',
  ga_admin_mock_tag_good_for_covisit: '适合协访',
  ga_admin_mock_tag_many_open_feedback: '开放反馈多',
  ga_admin_mock_customer_clinical_1_insight: '对慢性偏头痛长期管理认同高，重点关注患者筛选与院内路径。',
  ga_admin_mock_customer_clinical_1_next_action: '联合 GA 梳理机构支付沟通口径',
  ga_admin_mock_person_zhou_wenting: '周文婷',
  ga_admin_mock_title_associate_director_physician_neuro: '神经内科副主任医师',
  ga_admin_mock_city_guangzhou: '广州',
  ga_admin_mock_priority_medium: '中优先',
  ga_admin_mock_tag_case_support_needed: '需病例支持',
  ga_admin_mock_tag_new_product_interest: '新产品关注',
  ga_admin_mock_customer_clinical_2_insight: '对疾病认知充分，但对长期治疗价值仍需证据强化。',
  ga_admin_mock_customer_clinical_2_next_action: '补充真实世界证据与病例讨论',
  ga_admin_mock_person_zhao_yifan: '赵一凡',
  ga_admin_mock_title_headache_center_lead: '头痛中心负责人',
  ga_admin_mock_city_shanghai: '上海',
  ga_admin_mock_tag_process_barrier: '流程阻力',
  ga_admin_mock_tag_convertible: '可转化',
  ga_admin_mock_customer_clinical_3_insight: '积极提问，但对院内流程衔接仍存疑虑。',
  ga_admin_mock_customer_clinical_3_next_action: '协访时加入机构路径说明',
  ga_admin_mock_person_chen_haifeng: '陈海峰',
  ga_admin_mock_tag_ga_focus: 'GA重点',
  ga_admin_mock_tag_key_node: '关键节点',
  ga_admin_mock_tag_strong_relationship: '关系强',
  ga_admin_mock_customer_expert_1_insight: '熟悉机构关键人，对支付讨论开放，适合作为联动支点。',
  ga_admin_mock_customer_expert_1_next_action: '与 GBA 共创院内推进叙事',
  ga_admin_mock_person_wang_jingyi: '王静宜',
  ga_admin_mock_title_pharmacoeconomist: '药经学家',
  ga_admin_mock_tag_budget_impact: '预算影响',
  ga_admin_mock_tag_second_visit_needed: '需二次拜访',
  ga_admin_mock_customer_expert_2_insight: '已认可部分 NRDL 信息，但对预算影响仍有疑问。',
  ga_admin_mock_customer_expert_2_next_action: '补充成本效益测算与同类案例',
  ga_admin_mock_person_gu_chengyuan: '顾承远',
  ga_admin_mock_tag_needs_icebreaker: '需破冰',
  ga_admin_mock_tag_high_synergy_opportunity: '协同机会高',
  ga_admin_mock_customer_expert_3_insight: '客户熟悉度一般，当前更多停留在概念了解层面。',
  ga_admin_mock_customer_expert_3_next_action: '优先安排与临床共同拜访',
  ga_admin_mock_region_southwest: '西南',
  ga_admin_mock_region_south: '华南',
  ga_admin_mock_region_east: '华东',
  ga_admin_mock_institution_1_status: '联合突破中',
  ga_admin_mock_institution_1_insight: '临床端成熟度高，政策端具备放大条件，是当前最佳联合样板。',
  ga_admin_mock_institution_2_status: '补齐支付叙事',
  ga_admin_mock_institution_2_insight: '需要将临床价值表达转成更明确的支付与准入话术。',
  ga_admin_mock_level_medium_low: '中低',
  ga_admin_mock_institution_3_status: '协访优先',
  ga_admin_mock_institution_3_insight: '人物触达基本具备，但机构层面的共识尚未形成闭环。',
  ga_admin_mock_person_luo_zhixing: '罗知行',
  ga_admin_mock_person_tang_ziyu: '唐子瑜',
  ga_admin_mock_person_he_ruotong: '何若彤',
  ga_admin_mock_relation_network_1_summary: '卫经专家与头痛中心关键临床之间已形成稳定连接，适合打造协访样板。',
  ga_admin_mock_relation_network_1_next_action: '以“院内准入 + 长期管理”做一次双线联动拜访。',
  ga_admin_mock_person_liu_shengnan: '刘盛楠',
  ga_admin_mock_person_zheng_mingxuan: '郑明轩',
  ga_admin_mock_relation_network_2_summary: '临床与专家各自反馈丰富，但缺少围绕同一机构目标的统一动作。',
  ga_admin_mock_relation_network_2_next_action: '先补齐客户反馈信息，再匹配联合触达节奏。',
  ga_admin_mock_person_xu_jingwen: '许靖文',
  ga_admin_mock_person_xu_nianci: '许念慈',
  ga_admin_mock_person_jiang_wei: '姜维',
  ga_admin_mock_relation_network_3_summary: '当前人物覆盖足够，但连接强度不均，需借协访快速拉齐认知。',
  ga_admin_mock_relation_network_3_next_action: '围绕重点专家与关键临床建立一条高频协同链路。',
  ga_admin_mock_relation_type_high_value: '协同高价值',
  ga_admin_mock_strength_strong: '强',
  ga_admin_mock_relation_suggestion_1: '优先安排联合拜访',
  ga_admin_mock_relation_type_info_connected: '信息可打通',
  ga_admin_mock_relation_suggestion_2: '先统一支付价值表达',
  ga_admin_mock_relation_type_influence_chain: '潜在影响链',
  ga_admin_mock_relation_suggestion_3: '增加一次协访试探合作意愿',
  ga_admin_mock_execution_card_gba_title: 'GBA团队执行',
  ga_admin_mock_execution_card_gba_subvalue: '48 / 58 位临床客户覆盖',
  ga_admin_mock_execution_card_ga_title: 'GA团队执行',
  ga_admin_mock_execution_card_ga_subvalue: '31 / 41 位关键专家完成沟通',
  ga_admin_mock_execution_card_covisit_title: '已执行拜访数',
  ga_admin_mock_execution_card_covisit_subvalue: '较上月 +6',
  ga_admin_mock_execution_card_connection_title: '反馈填写率',
  ga_admin_mock_execution_card_connection_subvalue: '仍有 11 次拜访未填写反馈',
  ga_admin_mock_pipeline_planned: '已计划',
  ga_admin_mock_pipeline_visited: '已拜访',
  ga_admin_mock_pipeline_feedback_received: '已反馈',
  ga_admin_mock_pipeline_strategy_pending: '待转策略',
  ga_admin_mock_pipeline_second_follow_up: '待二次推进',
  ga_admin_mock_queue_1_title: '华西医院联合攻坚',
  ga_admin_mock_queue_status_pending_schedule: '待排期',
  ga_admin_mock_queue_1_owners: 'GBA西南组 / GA西南组',
  ga_admin_mock_queue_1_desc: '临床端认可度高，政策端具备转化条件，适合作为上市与 NRDL 样板机构。',
  ga_admin_mock_queue_2_title: '瑞金医院信息打通',
  ga_admin_mock_queue_status_in_progress: '进行中',
  ga_admin_mock_queue_2_owners: 'GBA华东组 / GA华东组',
  ga_admin_mock_queue_2_desc: '已识别关键专家与关键临床，但反馈尚未合并到机构视角。',
  ga_admin_mock_queue_3_title: '中山一院价值叙事补齐',
  ga_admin_mock_queue_status_outline_pending: '待生成提纲',
  ga_admin_mock_queue_3_owners: 'GA华南组',
  ga_admin_mock_queue_3_desc: '建议先由 AI 生成协访话术，再补一次联合沟通。',
  ga_admin_mock_quality_alert_1: '5 位关键专家的开放问题尚未形成后续动作建议。',
  ga_admin_mock_quality_alert_2: '3 类重点客户的临床端与专家端反馈未补齐，影响整体判断。',
  ga_admin_mock_quality_alert_3: '协访后 7 日内未回填纪要的任务共有 4 条，建议优先补全。',
  ga_admin_mock_strategy_1_title: '上市期联合打法',
  ga_admin_mock_strategy_1_desc: '优先选择“临床认同已起势 + 专家愿意讨论支付”的机构，集中资源打造 2-3 个样板。',
  ga_admin_mock_strategy_1_action_1: '锁定样板机构',
  ga_admin_mock_strategy_1_action_2: '安排双线协访',
  ga_admin_mock_strategy_1_action_3: '形成复用模板',
  ga_admin_mock_strategy_1_prompt: '请基于当前 GA管理员驾驶舱数据，生成新产品上市期的样板机构推进策略。',
  ga_admin_mock_strategy_2_title: 'NRDL 沟通深化',
  ga_admin_mock_strategy_2_desc: '针对预算影响与院内准入疑问较多的机构，统一输出价值叙事与常见异议应答。',
  ga_admin_mock_strategy_2_action_1: '统一价值表述',
  ga_admin_mock_strategy_2_action_2: '补充成本效益说明',
  ga_admin_mock_strategy_2_action_3: '定位关键决策人',
  ga_admin_mock_strategy_2_prompt: '请帮我生成一份面向卫经专家的 NRDL 关键沟通框架。',
  ga_admin_mock_strategy_3_title: '团队反馈闭环机制',
  ga_admin_mock_strategy_3_desc: '把拜访反馈与客户跟进做成标准动作，避免 GBA 与 GA 各自推进却无法汇总。',
  ga_admin_mock_strategy_3_action_1: '建立客户反馈主档',
  ga_admin_mock_strategy_3_action_2: '协访后自动纪要',
  ga_admin_mock_strategy_3_action_3: '共享重点问题池',
  ga_admin_mock_strategy_3_prompt: '请给我一套 GBA 与 GA 团队的协同管理 SOP。',
  ga_admin_mock_opportunity_1_stage: '可打造样板',
  ga_admin_mock_opportunity_1_driver: '临床与专家端均已形成正向信号',
  ga_admin_mock_opportunity_2_stage: '需补支付叙事',
  ga_admin_mock_opportunity_2_driver: '临床认知到位，专家端仍需价值闭环',
  ga_admin_mock_opportunity_3_stage: '协访窗口期',
  ga_admin_mock_opportunity_3_driver: '关系已初步形成，仍需补齐一次客户反馈闭环',
  ga_admin_mock_risk_1_title: '预算影响疑虑聚集',
  ga_admin_mock_level_medium_high: '中高',
  ga_admin_mock_risk_1_desc: 'GA 反馈中“预算影响不清晰”出现频率提升，华南与华东尤为明显。',
  ga_admin_mock_risk_2_title: '临床开放问题未闭环',
  ga_admin_mock_risk_2_desc: '多个临床医生持续提到患者筛选与院内流程，但暂无统一回答框架。',
  ga_admin_mock_risk_3_title: '重点客户跟进节奏偏慢',
  ga_admin_mock_risk_3_desc: '部分高潜客户已识别，但拜访与反馈填写尚未同步启动。',
  ga_admin_mock_report_prompt_1: '生成本周 GBA / GA 团队上市与 NRDL 推进周报',
  ga_admin_mock_report_prompt_2: '总结 5 位重点客户的风险、机会与下一步建议',
  ga_admin_mock_report_prompt_3: '生成面向管理层的策略摘要，突出客户覆盖与反馈进展',
};
